import React from 'react';
import { USE_V2_DESIGN } from '@rd-web-markets/market/dist/constants';
import { useSelector } from 'react-redux';
import AbstractClaimGroupChildPage from '@rd-web-markets/shared/dist/pages/abstract/AbstractClaimGroupChildPage';

const getDataCentreMainPage = () => {
  if (USE_V2_DESIGN) {
    return require('@rd-web-markets/market/dist/claim_group/data_centre/DataCentreMainPage').default;
  }
  return null;
};

const DataCentreMainPage = getDataCentreMainPage();

const DataCentreImportPage = AbstractClaimGroupChildPage({
  highlightedMenuItem: 'import_data',
  ClaimGroupChildPage: function ({ claimGroup }) {
    const user = useSelector((state) => state.auth.user);

    const canUploadTemplate = () => {
      if (user.account_type !== 'customer') return false;
      return !claimGroup.user_accesses.find(
        (ua) => ua.user_id === user.id
      )['can_upload_cost_template'];
    };

    return (
      <div className="ps-4 pe-4">
        <DataCentreMainPage
          claimGroup={claimGroup}
          canUploadTemplate={canUploadTemplate()}
          hideExportTab={true}
          hideTabs={true}
        />
      </div>
    );
  }
});

export default DataCentreImportPage;
